import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChartCommunicationService {

  @Output()
  loadChartsEmitter = new EventEmitter<void>();

  constructor() { }

  loadCharts(): void {
    this.loadChartsEmitter.emit();
  }

  cleanObservers() {
    this.loadChartsEmitter.observers = [];
  }

}
